/* @flow */


/**
 * Serializes a supply chain object to the string format used by prebid.js
 *
 * @param {anyObject} schain - Supply chain object with ver, complete, and nodes properties
 * @param {Array<string>} [nodesProperties=[]] - Array of node properties to serialize
 * @returns {string|null} - Serialized supply chain string or null if invalid
 *
 * @example
 * const schain = {
 *   ver: "1.0",
 *   complete: 1,
 *   nodes: [
 *     { asi: "directseller.com", sid: "00001", hp: 1, rid: "bid-request-1", name: "Example", domain: "example.com" }
 *   ]
 * };
 * serializeSupplyChain(schain, ['asi', 'sid', 'hp', 'rid', 'name', 'domain', 'ext']);
 * // Returns: "1.0,1!directseller.com,00001,1,bid-request-1,Example,example.com,"
 */
export function serializeSupplyChain(
  schain: anyObject,
  nodesProperties: Array<string> = []
): string | null {
  // Return null if schain is invalid or has no nodes
  if (!schain || !schain.nodes) {
    return null;
  }

  // Ensure nodesProperties is an array
  const props = Array.isArray(nodesProperties) ? nodesProperties : [];

  // Build header: version,complete!
  const header = `${schain.ver},${schain.complete}!`;

  // Serialize each node
  const nodes = schain.nodes
    .map(node =>
      props
        .map(prop => {
          // Get property value, default to empty string if missing, then URL-encode
          const value = node[prop] || '';
          // URL-encode the value and escape ! characters as %21
          // $FlowFixMe[prop-missing]
          return encodeURIComponent(String(value)).replaceAll('!', '%21');
        })
        .join(',')
    )
    .join('!');

  return header + nodes;
}
